import { getToken } from "firebase/messaging";
import { getFirebaseMessaging, VAPID_KEY } from "./config";
import { apiFetchClient } from "../api/client";
import { endpoints } from "../api/endpoints";

const FCM_TOKEN_KEY = "a2z_admin_fcm_token";

export async function requestFcmToken(): Promise<string | null> {
  const messaging = getFirebaseMessaging();
  if (!messaging || !VAPID_KEY) return null;

  try {
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        const reg = await navigator.serviceWorker.register("/admin-sw.js");
        return await getToken(messaging, {
          vapidKey: VAPID_KEY,
          serviceWorkerRegistration: reg,
        }) || null;
      } catch {
        if (attempt < 2) await new Promise((r) => setTimeout(r, 2000));
      }
    }
    return null;
  } catch (error) {
    console.warn("FCM token request failed", error);
    return null;
  }
}

export async function registerFcmTokenWithBackend(
  token: string,
): Promise<void> {
  try {
    await apiFetchClient(endpoints.admin.fcmTokens, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });
    localStorage.setItem(FCM_TOKEN_KEY, token);
  } catch (error) {
    console.warn("FCM token registration failed", error);
  }
}

export function getStoredFcmToken(): string | null {
  return localStorage.getItem(FCM_TOKEN_KEY);
}

export async function deregisterFcmTokenFromBackend(): Promise<void> {
  const token = localStorage.getItem(FCM_TOKEN_KEY);
  if (!token) return;
  try {
    await apiFetchClient(endpoints.admin.fcmTokens, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });
  } catch (error) {
    console.warn("FCM token deregistration failed", error);
  } finally {
    localStorage.removeItem(FCM_TOKEN_KEY);
  }
}
